export const sliderWidth = 1126;
const gapWidth = 26;
export const shownNumber = 4;
export const slideContainerWidth = sliderWidth + gapWidth;
// ページブレイクポイントは1024pxを使用していますが、スライダーの見切れのみに対応するために1280pxにしています。
export const breakPoint = '1280px';
